import { render, staticRenderFns } from "./letters.vue?vue&type=template&id=499cdb17&"
import script from "./letters.vue?vue&type=script&lang=js&"
export * from "./letters.vue?vue&type=script&lang=js&"
import style0 from "./letters.vue?vue&type=style&index=0&id=499cdb17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports